// Everything this slice caches. A request invalidates the prefix, so the list and the stats are
// read again together.
export const QR_BATCHES_PREFIX = ['qr-batches'] as const;

export const qrBatchListKey = () => [...QR_BATCHES_PREFIX, 'list'] as const;

export const qrBatchStatsKey = () => [...QR_BATCHES_PREFIX, 'stats'] as const;
